import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { IntegrationLogo, Text } from 'components';
import { theme, toRem } from 'design';
import { IntegrationType } from 'types';

const Layout = styled.div<Partial<IEmployeeInfoProps>>`
  display: flex;
  flex-flow: column;
  width: 100%;
  align-items: center;
  padding: ${toRem(12)};

  p {
    text-align: center;
    width: 100%;
    word-break: break-word;

    &.grey {
      color: ${theme.color.neutral[500]};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      direction: ltr;
    }
  }

  ${({ showBorder }) =>
    showBorder &&
    css`
      border: ${toRem(1)} solid ${theme.color.neutral[200]};
      border-radius: ${toRem(theme.borderRadius.small)};
      background-color: ${theme.color.neutral[25]};
      margin-bottom: ${toRem(16)};
    `}

  ${({ width }) => css`
    @media (min-width: ${theme.breakpoint.small}px) {
      width: ${toRem(width)};
    }
  `}
`;

interface IEmployeeInfoProps {
  dataCy: string;
  name: string;
  employeeId?: string;
  type: string;
  showBorder?: boolean;
  width?: number;
}

const EmployeeInfo: FC<IEmployeeInfoProps> = ({ name, employeeId, type, dataCy, width, showBorder = true }) => (
  <Layout data-cy={`${dataCy}-employee-info`} showBorder={showBorder} width={width}>
    <IntegrationLogo type={type as IntegrationType} />
    <Text fontWeight="semibold">{name}</Text>
    {employeeId && (
      <Text size="small" className="grey">
        Employee Id: {employeeId}
      </Text>
    )}
  </Layout>
);

export default EmployeeInfo;
